/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Member } from '../models/Member';
import type { MemberDetail } from '../models/MemberDetail';
import type { MemberDetailWithTeams } from '../models/MemberDetailWithTeams';
import type { MemberForMemberList } from '../models/MemberForMemberList';
import type { MemberUpdateRequest } from '../models/MemberUpdateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MembersService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Members
   * @param slug
   * @returns MemberForMemberList Successful Response
   * @throws ApiError
   */
  public getMembersV1WorkspacesSlugMembersGet(
    slug: string
  ): CancelablePromise<Array<MemberForMemberList>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/members',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Me
   * @param slug
   * @returns MemberDetailWithTeams Successful Response
   * @throws ApiError
   */
  public getMeV1WorkspacesSlugMembersMeGet(slug: string): CancelablePromise<MemberDetailWithTeams> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/members/me',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Member
   * @param memberId
   * @param slug
   * @returns any Successful Response
   * @throws ApiError
   */
  public getMemberV1WorkspacesSlugMembersMemberIdGet(
    memberId: number,
    slug: string
  ): CancelablePromise<MemberDetailWithTeams | Member> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/members/{member_id}',
      path: {
        member_id: memberId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Member
   * @param memberId
   * @param slug
   * @param requestBody
   * @returns MemberDetailWithTeams Successful Response
   * @throws ApiError
   */
  public updateMemberV1WorkspacesSlugMembersMemberIdPatch(
    memberId: number,
    slug: string,
    requestBody: MemberUpdateRequest
  ): CancelablePromise<MemberDetailWithTeams> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/workspaces/{slug}/members/{member_id}',
      path: {
        member_id: memberId,
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid role (Deactivate is not allowed in this action. Use /v1/workspaces/{slug}/members/{member_id}/deactivate instead)`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Deactivate Member
   * @param memberId
   * @param slug
   * @returns MemberDetail Successful Response
   * @throws ApiError
   */
  public deactivateMemberV1WorkspacesSlugMembersMemberIdDelete(
    memberId: number,
    slug: string
  ): CancelablePromise<MemberDetail> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/workspaces/{slug}/members/{member_id}',
      path: {
        member_id: memberId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Revoke Member Tokens
   * 워크스페이스 관리자 전용: 특정 멤버의 모든 JWT 토큰을 무효화합니다.
   * @param memberId
   * @param slug
   * @returns void
   * @throws ApiError
   */
  public revokeMemberTokensV1WorkspacesSlugMembersMemberIdRevokeTokensPost(
    memberId: number,
    slug: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/members/{member_id}/revoke-tokens',
      path: {
        member_id: memberId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
